/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Tournated Dashboard API
 * Internal REST API consumed by the Tournated dashboard. Authenticated with a user JWT (Authorization: Bearer ...).
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  DashboardCreateLeagueCustomTag,
  DashboardCreateLeagueLevel,
  DashboardCreateLeagueRegion,
  DashboardCreateLeagueSeason,
  DashboardLeagueCustomTagsControllerCreate400,
  DashboardLeagueCustomTagsControllerCreate401,
  DashboardLeagueCustomTagsControllerCreate429,
  DashboardLeagueCustomTagsControllerList400,
  DashboardLeagueCustomTagsControllerList401,
  DashboardLeagueCustomTagsControllerList429,
  DashboardLeagueCustomTagsControllerListParams,
  DashboardLeagueCustomTagsControllerRemove400,
  DashboardLeagueCustomTagsControllerRemove401,
  DashboardLeagueCustomTagsControllerRemove404,
  DashboardLeagueCustomTagsControllerRemove429,
  DashboardLeagueCustomTagsControllerRemoveParams,
  DashboardLeagueCustomTagsControllerReorder400,
  DashboardLeagueCustomTagsControllerReorder401,
  DashboardLeagueCustomTagsControllerReorder429,
  DashboardLeagueCustomTagsControllerUpdate400,
  DashboardLeagueCustomTagsControllerUpdate401,
  DashboardLeagueCustomTagsControllerUpdate404,
  DashboardLeagueCustomTagsControllerUpdate429,
  DashboardLeagueCustomTagsControllerUpdateParams,
  DashboardLeagueLevelsControllerCreate400,
  DashboardLeagueLevelsControllerCreate401,
  DashboardLeagueLevelsControllerCreate429,
  DashboardLeagueLevelsControllerList400,
  DashboardLeagueLevelsControllerList401,
  DashboardLeagueLevelsControllerList429,
  DashboardLeagueLevelsControllerListParams,
  DashboardLeagueLevelsControllerRemove400,
  DashboardLeagueLevelsControllerRemove401,
  DashboardLeagueLevelsControllerRemove404,
  DashboardLeagueLevelsControllerRemove429,
  DashboardLeagueLevelsControllerRemoveParams,
  DashboardLeagueLevelsControllerReorder400,
  DashboardLeagueLevelsControllerReorder401,
  DashboardLeagueLevelsControllerReorder429,
  DashboardLeagueLevelsControllerUpdate400,
  DashboardLeagueLevelsControllerUpdate401,
  DashboardLeagueLevelsControllerUpdate404,
  DashboardLeagueLevelsControllerUpdate429,
  DashboardLeagueLevelsControllerUpdateParams,
  DashboardLeagueRegionsControllerCreate400,
  DashboardLeagueRegionsControllerCreate401,
  DashboardLeagueRegionsControllerCreate429,
  DashboardLeagueRegionsControllerList400,
  DashboardLeagueRegionsControllerList401,
  DashboardLeagueRegionsControllerList429,
  DashboardLeagueRegionsControllerListParams,
  DashboardLeagueRegionsControllerRemove400,
  DashboardLeagueRegionsControllerRemove401,
  DashboardLeagueRegionsControllerRemove404,
  DashboardLeagueRegionsControllerRemove429,
  DashboardLeagueRegionsControllerRemoveParams,
  DashboardLeagueRegionsControllerReorder400,
  DashboardLeagueRegionsControllerReorder401,
  DashboardLeagueRegionsControllerReorder429,
  DashboardLeagueRegionsControllerUpdate400,
  DashboardLeagueRegionsControllerUpdate401,
  DashboardLeagueRegionsControllerUpdate404,
  DashboardLeagueRegionsControllerUpdate429,
  DashboardLeagueRegionsControllerUpdateParams,
  DashboardLeagueSeasonsControllerCreate400,
  DashboardLeagueSeasonsControllerCreate401,
  DashboardLeagueSeasonsControllerCreate429,
  DashboardLeagueSeasonsControllerList400,
  DashboardLeagueSeasonsControllerList401,
  DashboardLeagueSeasonsControllerList429,
  DashboardLeagueSeasonsControllerListParams,
  DashboardLeagueSeasonsControllerRemove400,
  DashboardLeagueSeasonsControllerRemove401,
  DashboardLeagueSeasonsControllerRemove404,
  DashboardLeagueSeasonsControllerRemove429,
  DashboardLeagueSeasonsControllerRemoveParams,
  DashboardLeagueSeasonsControllerReorder400,
  DashboardLeagueSeasonsControllerReorder401,
  DashboardLeagueSeasonsControllerReorder429,
  DashboardLeagueSeasonsControllerUpdate400,
  DashboardLeagueSeasonsControllerUpdate401,
  DashboardLeagueSeasonsControllerUpdate404,
  DashboardLeagueSeasonsControllerUpdate429,
  DashboardLeagueSeasonsControllerUpdateParams,
  DashboardReorderLeagueCustomTag,
  DashboardReorderLeagueLevel,
  DashboardReorderLeagueRegion,
  DashboardReorderLeagueSeason,
  DashboardUpdateLeagueCustomTag,
  DashboardUpdateLeagueLevel,
  DashboardUpdateLeagueRegion,
  DashboardUpdateLeagueSeason,
  LeagueCustomTag,
  LeagueLevel,
  LeagueRegion,
  LeagueSeason,
} from ".././schemas";
import { restClient } from "../../restClient";
import type { ErrorType, BodyType } from "../../restClient";

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

/**
 * A league's seasons, ordered by sorting position (nulls last, then creation time). `leagueId` (`lge_…`) is required and access-checked; the league must be a `LEAGUE`. Optional `keyword` filters on the title (case-insensitive substring). Not paginated.
 * @summary List league seasons (dashboard)
 */
export const dashboardLeagueSeasonsControllerList = (
  params: DashboardLeagueSeasonsControllerListParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<LeagueSeason[]>(
    { url: `/api/dashboard/v1/league-seasons`, method: "GET", params, signal },
    options
  );
};

export const getDashboardLeagueSeasonsControllerListQueryKey = (
  params: DashboardLeagueSeasonsControllerListParams
) => {
  return [`/api/dashboard/v1/league-seasons`, ...(params ? [params] : [])] as const;
};

export const getDashboardLeagueSeasonsControllerListQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardLeagueSeasonsControllerList>>,
  TError = ErrorType<
    | DashboardLeagueSeasonsControllerList400
    | DashboardLeagueSeasonsControllerList401
    | DashboardLeagueSeasonsControllerList429
  >,
>(
  params: DashboardLeagueSeasonsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueSeasonsControllerList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardLeagueSeasonsControllerListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardLeagueSeasonsControllerList>>
  > = ({ signal }) => dashboardLeagueSeasonsControllerList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardLeagueSeasonsControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardLeagueSeasonsControllerListQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeagueSeasonsControllerList>>
>;
export type DashboardLeagueSeasonsControllerListQueryError = ErrorType<
  | DashboardLeagueSeasonsControllerList400
  | DashboardLeagueSeasonsControllerList401
  | DashboardLeagueSeasonsControllerList429
>;

export function useDashboardLeagueSeasonsControllerList<
  TData = Awaited<ReturnType<typeof dashboardLeagueSeasonsControllerList>>,
  TError = ErrorType<
    | DashboardLeagueSeasonsControllerList400
    | DashboardLeagueSeasonsControllerList401
    | DashboardLeagueSeasonsControllerList429
  >,
>(
  params: DashboardLeagueSeasonsControllerListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueSeasonsControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeagueSeasonsControllerList>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeagueSeasonsControllerList<
  TData = Awaited<ReturnType<typeof dashboardLeagueSeasonsControllerList>>,
  TError = ErrorType<
    | DashboardLeagueSeasonsControllerList400
    | DashboardLeagueSeasonsControllerList401
    | DashboardLeagueSeasonsControllerList429
  >,
>(
  params: DashboardLeagueSeasonsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueSeasonsControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeagueSeasonsControllerList>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeagueSeasonsControllerList<
  TData = Awaited<ReturnType<typeof dashboardLeagueSeasonsControllerList>>,
  TError = ErrorType<
    | DashboardLeagueSeasonsControllerList400
    | DashboardLeagueSeasonsControllerList401
    | DashboardLeagueSeasonsControllerList429
  >,
>(
  params: DashboardLeagueSeasonsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueSeasonsControllerList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List league seasons (dashboard)
 */

export function useDashboardLeagueSeasonsControllerList<
  TData = Awaited<ReturnType<typeof dashboardLeagueSeasonsControllerList>>,
  TError = ErrorType<
    | DashboardLeagueSeasonsControllerList400
    | DashboardLeagueSeasonsControllerList401
    | DashboardLeagueSeasonsControllerList429
  >,
>(
  params: DashboardLeagueSeasonsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueSeasonsControllerList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardLeagueSeasonsControllerListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a season under the league identified by `leagueId` (`lge_…`). The league must be a `LEAGUE` and accessible to the caller. The new season appends last in the ordering.
 * @summary Create a league season (dashboard)
 */
export const dashboardLeagueSeasonsControllerCreate = (
  dashboardCreateLeagueSeason: BodyType<DashboardCreateLeagueSeason>,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<LeagueSeason>(
    {
      url: `/api/dashboard/v1/league-seasons`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: dashboardCreateLeagueSeason,
      signal,
    },
    options
  );
};

export const getDashboardLeagueSeasonsControllerCreateMutationOptions = <
  TError = ErrorType<
    | DashboardLeagueSeasonsControllerCreate400
    | DashboardLeagueSeasonsControllerCreate401
    | DashboardLeagueSeasonsControllerCreate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeagueSeasonsControllerCreate>>,
    TError,
    { data: BodyType<DashboardCreateLeagueSeason> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardLeagueSeasonsControllerCreate>>,
  TError,
  { data: BodyType<DashboardCreateLeagueSeason> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardLeagueSeasonsControllerCreate>>,
    { data: BodyType<DashboardCreateLeagueSeason> }
  > = (props) => {
    const { data } = props ?? {};

    return dashboardLeagueSeasonsControllerCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardLeagueSeasonsControllerCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeagueSeasonsControllerCreate>>
>;
export type DashboardLeagueSeasonsControllerCreateMutationBody =
  BodyType<DashboardCreateLeagueSeason>;
export type DashboardLeagueSeasonsControllerCreateMutationError = ErrorType<
  | DashboardLeagueSeasonsControllerCreate400
  | DashboardLeagueSeasonsControllerCreate401
  | DashboardLeagueSeasonsControllerCreate429
>;

/**
 * @summary Create a league season (dashboard)
 */
export const useDashboardLeagueSeasonsControllerCreate = <
  TError = ErrorType<
    | DashboardLeagueSeasonsControllerCreate400
    | DashboardLeagueSeasonsControllerCreate401
    | DashboardLeagueSeasonsControllerCreate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeagueSeasonsControllerCreate>>,
    TError,
    { data: BodyType<DashboardCreateLeagueSeason> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardLeagueSeasonsControllerCreate>>,
  TError,
  { data: BodyType<DashboardCreateLeagueSeason> },
  TContext
> => {
  const mutationOptions = getDashboardLeagueSeasonsControllerCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Rewrite the sort order of a league's seasons. `ids` must be the FULL set of the league's season public ids (`sea_…`) in the desired order — a partial, extra, or foreign set is a 400.
 * @summary Reorder league seasons (dashboard)
 */
export const dashboardLeagueSeasonsControllerReorder = (
  dashboardReorderLeagueSeason: BodyType<DashboardReorderLeagueSeason>,
  options?: SecondParameter<typeof restClient>
) => {
  return restClient<LeagueSeason[]>(
    {
      url: `/api/dashboard/v1/league-seasons/reorder`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: dashboardReorderLeagueSeason,
    },
    options
  );
};

export const getDashboardLeagueSeasonsControllerReorderMutationOptions = <
  TError = ErrorType<
    | DashboardLeagueSeasonsControllerReorder400
    | DashboardLeagueSeasonsControllerReorder401
    | DashboardLeagueSeasonsControllerReorder429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeagueSeasonsControllerReorder>>,
    TError,
    { data: BodyType<DashboardReorderLeagueSeason> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardLeagueSeasonsControllerReorder>>,
  TError,
  { data: BodyType<DashboardReorderLeagueSeason> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardLeagueSeasonsControllerReorder>>,
    { data: BodyType<DashboardReorderLeagueSeason> }
  > = (props) => {
    const { data } = props ?? {};

    return dashboardLeagueSeasonsControllerReorder(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardLeagueSeasonsControllerReorderMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeagueSeasonsControllerReorder>>
>;
export type DashboardLeagueSeasonsControllerReorderMutationBody =
  BodyType<DashboardReorderLeagueSeason>;
export type DashboardLeagueSeasonsControllerReorderMutationError = ErrorType<
  | DashboardLeagueSeasonsControllerReorder400
  | DashboardLeagueSeasonsControllerReorder401
  | DashboardLeagueSeasonsControllerReorder429
>;

/**
 * @summary Reorder league seasons (dashboard)
 */
export const useDashboardLeagueSeasonsControllerReorder = <
  TError = ErrorType<
    | DashboardLeagueSeasonsControllerReorder400
    | DashboardLeagueSeasonsControllerReorder401
    | DashboardLeagueSeasonsControllerReorder429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeagueSeasonsControllerReorder>>,
    TError,
    { data: BodyType<DashboardReorderLeagueSeason> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardLeagueSeasonsControllerReorder>>,
  TError,
  { data: BodyType<DashboardReorderLeagueSeason> },
  TContext
> => {
  const mutationOptions = getDashboardLeagueSeasonsControllerReorderMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Partial update. `leagueId` (`lge_…`) scopes + authorizes the request; the `:id` (`sea_…`) must belong to that league (404 otherwise). The season's owning league cannot be changed.
 * @summary Update a league season (dashboard)
 */
export const dashboardLeagueSeasonsControllerUpdate = (
  id: string,
  dashboardUpdateLeagueSeason: BodyType<DashboardUpdateLeagueSeason>,
  params: DashboardLeagueSeasonsControllerUpdateParams,
  options?: SecondParameter<typeof restClient>
) => {
  return restClient<LeagueSeason>(
    {
      url: `/api/dashboard/v1/league-seasons/${id}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: dashboardUpdateLeagueSeason,
      params,
    },
    options
  );
};

export const getDashboardLeagueSeasonsControllerUpdateMutationOptions = <
  TError = ErrorType<
    | DashboardLeagueSeasonsControllerUpdate400
    | DashboardLeagueSeasonsControllerUpdate401
    | DashboardLeagueSeasonsControllerUpdate404
    | DashboardLeagueSeasonsControllerUpdate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeagueSeasonsControllerUpdate>>,
    TError,
    {
      id: string;
      data: BodyType<DashboardUpdateLeagueSeason>;
      params: DashboardLeagueSeasonsControllerUpdateParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardLeagueSeasonsControllerUpdate>>,
  TError,
  {
    id: string;
    data: BodyType<DashboardUpdateLeagueSeason>;
    params: DashboardLeagueSeasonsControllerUpdateParams;
  },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardLeagueSeasonsControllerUpdate>>,
    {
      id: string;
      data: BodyType<DashboardUpdateLeagueSeason>;
      params: DashboardLeagueSeasonsControllerUpdateParams;
    }
  > = (props) => {
    const { id, data, params } = props ?? {};

    return dashboardLeagueSeasonsControllerUpdate(id, data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardLeagueSeasonsControllerUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeagueSeasonsControllerUpdate>>
>;
export type DashboardLeagueSeasonsControllerUpdateMutationBody =
  BodyType<DashboardUpdateLeagueSeason>;
export type DashboardLeagueSeasonsControllerUpdateMutationError = ErrorType<
  | DashboardLeagueSeasonsControllerUpdate400
  | DashboardLeagueSeasonsControllerUpdate401
  | DashboardLeagueSeasonsControllerUpdate404
  | DashboardLeagueSeasonsControllerUpdate429
>;

/**
 * @summary Update a league season (dashboard)
 */
export const useDashboardLeagueSeasonsControllerUpdate = <
  TError = ErrorType<
    | DashboardLeagueSeasonsControllerUpdate400
    | DashboardLeagueSeasonsControllerUpdate401
    | DashboardLeagueSeasonsControllerUpdate404
    | DashboardLeagueSeasonsControllerUpdate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeagueSeasonsControllerUpdate>>,
    TError,
    {
      id: string;
      data: BodyType<DashboardUpdateLeagueSeason>;
      params: DashboardLeagueSeasonsControllerUpdateParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardLeagueSeasonsControllerUpdate>>,
  TError,
  {
    id: string;
    data: BodyType<DashboardUpdateLeagueSeason>;
    params: DashboardLeagueSeasonsControllerUpdateParams;
  },
  TContext
> => {
  const mutationOptions = getDashboardLeagueSeasonsControllerUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Delete a season. `leagueId` (`lge_…`) scopes + authorizes the request; the `:id` (`sea_…`) must belong to that league (404 otherwise). Association links referencing it cascade away.
 * @summary Delete a league season (dashboard)
 */
export const dashboardLeagueSeasonsControllerRemove = (
  id: string,
  params: DashboardLeagueSeasonsControllerRemoveParams,
  options?: SecondParameter<typeof restClient>
) => {
  return restClient<void>(
    { url: `/api/dashboard/v1/league-seasons/${id}`, method: "DELETE", params },
    options
  );
};

export const getDashboardLeagueSeasonsControllerRemoveMutationOptions = <
  TError = ErrorType<
    | DashboardLeagueSeasonsControllerRemove400
    | DashboardLeagueSeasonsControllerRemove401
    | DashboardLeagueSeasonsControllerRemove404
    | DashboardLeagueSeasonsControllerRemove429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeagueSeasonsControllerRemove>>,
    TError,
    { id: string; params: DashboardLeagueSeasonsControllerRemoveParams },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardLeagueSeasonsControllerRemove>>,
  TError,
  { id: string; params: DashboardLeagueSeasonsControllerRemoveParams },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardLeagueSeasonsControllerRemove>>,
    { id: string; params: DashboardLeagueSeasonsControllerRemoveParams }
  > = (props) => {
    const { id, params } = props ?? {};

    return dashboardLeagueSeasonsControllerRemove(id, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardLeagueSeasonsControllerRemoveMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeagueSeasonsControllerRemove>>
>;

export type DashboardLeagueSeasonsControllerRemoveMutationError = ErrorType<
  | DashboardLeagueSeasonsControllerRemove400
  | DashboardLeagueSeasonsControllerRemove401
  | DashboardLeagueSeasonsControllerRemove404
  | DashboardLeagueSeasonsControllerRemove429
>;

/**
 * @summary Delete a league season (dashboard)
 */
export const useDashboardLeagueSeasonsControllerRemove = <
  TError = ErrorType<
    | DashboardLeagueSeasonsControllerRemove400
    | DashboardLeagueSeasonsControllerRemove401
    | DashboardLeagueSeasonsControllerRemove404
    | DashboardLeagueSeasonsControllerRemove429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeagueSeasonsControllerRemove>>,
    TError,
    { id: string; params: DashboardLeagueSeasonsControllerRemoveParams },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardLeagueSeasonsControllerRemove>>,
  TError,
  { id: string; params: DashboardLeagueSeasonsControllerRemoveParams },
  TContext
> => {
  const mutationOptions = getDashboardLeagueSeasonsControllerRemoveMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * A league's regions with their seasons, ordered by sorting position (nulls last, then creation time). `leagueId` (`lge_…`) is required and access-checked; the league must be a `LEAGUE`. Optional `keyword` filters on the title; optional `seasonIds` (`sea_…`) narrows to regions belonging to the given seasons. Not paginated.
 * @summary List league regions (dashboard)
 */
export const dashboardLeagueRegionsControllerList = (
  params: DashboardLeagueRegionsControllerListParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<LeagueRegion[]>(
    { url: `/api/dashboard/v1/league-regions`, method: "GET", params, signal },
    options
  );
};

export const getDashboardLeagueRegionsControllerListQueryKey = (
  params: DashboardLeagueRegionsControllerListParams
) => {
  return [`/api/dashboard/v1/league-regions`, ...(params ? [params] : [])] as const;
};

export const getDashboardLeagueRegionsControllerListQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardLeagueRegionsControllerList>>,
  TError = ErrorType<
    | DashboardLeagueRegionsControllerList400
    | DashboardLeagueRegionsControllerList401
    | DashboardLeagueRegionsControllerList429
  >,
>(
  params: DashboardLeagueRegionsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueRegionsControllerList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardLeagueRegionsControllerListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardLeagueRegionsControllerList>>
  > = ({ signal }) => dashboardLeagueRegionsControllerList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardLeagueRegionsControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardLeagueRegionsControllerListQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeagueRegionsControllerList>>
>;
export type DashboardLeagueRegionsControllerListQueryError = ErrorType<
  | DashboardLeagueRegionsControllerList400
  | DashboardLeagueRegionsControllerList401
  | DashboardLeagueRegionsControllerList429
>;

export function useDashboardLeagueRegionsControllerList<
  TData = Awaited<ReturnType<typeof dashboardLeagueRegionsControllerList>>,
  TError = ErrorType<
    | DashboardLeagueRegionsControllerList400
    | DashboardLeagueRegionsControllerList401
    | DashboardLeagueRegionsControllerList429
  >,
>(
  params: DashboardLeagueRegionsControllerListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueRegionsControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeagueRegionsControllerList>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeagueRegionsControllerList<
  TData = Awaited<ReturnType<typeof dashboardLeagueRegionsControllerList>>,
  TError = ErrorType<
    | DashboardLeagueRegionsControllerList400
    | DashboardLeagueRegionsControllerList401
    | DashboardLeagueRegionsControllerList429
  >,
>(
  params: DashboardLeagueRegionsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueRegionsControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeagueRegionsControllerList>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeagueRegionsControllerList<
  TData = Awaited<ReturnType<typeof dashboardLeagueRegionsControllerList>>,
  TError = ErrorType<
    | DashboardLeagueRegionsControllerList400
    | DashboardLeagueRegionsControllerList401
    | DashboardLeagueRegionsControllerList429
  >,
>(
  params: DashboardLeagueRegionsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueRegionsControllerList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List league regions (dashboard)
 */

export function useDashboardLeagueRegionsControllerList<
  TData = Awaited<ReturnType<typeof dashboardLeagueRegionsControllerList>>,
  TError = ErrorType<
    | DashboardLeagueRegionsControllerList400
    | DashboardLeagueRegionsControllerList401
    | DashboardLeagueRegionsControllerList429
  >,
>(
  params: DashboardLeagueRegionsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueRegionsControllerList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardLeagueRegionsControllerListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a region under `leagueId` (`lge_…`), attaching the given seasons (empty/omitted ⇒ all seasons). Every `sea_…` id must belong to the same league (else 400). Appends last.
 * @summary Create a league region (dashboard)
 */
export const dashboardLeagueRegionsControllerCreate = (
  dashboardCreateLeagueRegion: BodyType<DashboardCreateLeagueRegion>,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<LeagueRegion>(
    {
      url: `/api/dashboard/v1/league-regions`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: dashboardCreateLeagueRegion,
      signal,
    },
    options
  );
};

export const getDashboardLeagueRegionsControllerCreateMutationOptions = <
  TError = ErrorType<
    | DashboardLeagueRegionsControllerCreate400
    | DashboardLeagueRegionsControllerCreate401
    | DashboardLeagueRegionsControllerCreate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeagueRegionsControllerCreate>>,
    TError,
    { data: BodyType<DashboardCreateLeagueRegion> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardLeagueRegionsControllerCreate>>,
  TError,
  { data: BodyType<DashboardCreateLeagueRegion> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardLeagueRegionsControllerCreate>>,
    { data: BodyType<DashboardCreateLeagueRegion> }
  > = (props) => {
    const { data } = props ?? {};

    return dashboardLeagueRegionsControllerCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardLeagueRegionsControllerCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeagueRegionsControllerCreate>>
>;
export type DashboardLeagueRegionsControllerCreateMutationBody =
  BodyType<DashboardCreateLeagueRegion>;
export type DashboardLeagueRegionsControllerCreateMutationError = ErrorType<
  | DashboardLeagueRegionsControllerCreate400
  | DashboardLeagueRegionsControllerCreate401
  | DashboardLeagueRegionsControllerCreate429
>;

/**
 * @summary Create a league region (dashboard)
 */
export const useDashboardLeagueRegionsControllerCreate = <
  TError = ErrorType<
    | DashboardLeagueRegionsControllerCreate400
    | DashboardLeagueRegionsControllerCreate401
    | DashboardLeagueRegionsControllerCreate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeagueRegionsControllerCreate>>,
    TError,
    { data: BodyType<DashboardCreateLeagueRegion> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardLeagueRegionsControllerCreate>>,
  TError,
  { data: BodyType<DashboardCreateLeagueRegion> },
  TContext
> => {
  const mutationOptions = getDashboardLeagueRegionsControllerCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Rewrite the sort order of a league's regions. `ids` must be the FULL set of the league's region public ids (`reg_…`) in the desired order — partial/extra/foreign sets are a 400.
 * @summary Reorder league regions (dashboard)
 */
export const dashboardLeagueRegionsControllerReorder = (
  dashboardReorderLeagueRegion: BodyType<DashboardReorderLeagueRegion>,
  options?: SecondParameter<typeof restClient>
) => {
  return restClient<LeagueRegion[]>(
    {
      url: `/api/dashboard/v1/league-regions/reorder`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: dashboardReorderLeagueRegion,
    },
    options
  );
};

export const getDashboardLeagueRegionsControllerReorderMutationOptions = <
  TError = ErrorType<
    | DashboardLeagueRegionsControllerReorder400
    | DashboardLeagueRegionsControllerReorder401
    | DashboardLeagueRegionsControllerReorder429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeagueRegionsControllerReorder>>,
    TError,
    { data: BodyType<DashboardReorderLeagueRegion> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardLeagueRegionsControllerReorder>>,
  TError,
  { data: BodyType<DashboardReorderLeagueRegion> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardLeagueRegionsControllerReorder>>,
    { data: BodyType<DashboardReorderLeagueRegion> }
  > = (props) => {
    const { data } = props ?? {};

    return dashboardLeagueRegionsControllerReorder(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardLeagueRegionsControllerReorderMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeagueRegionsControllerReorder>>
>;
export type DashboardLeagueRegionsControllerReorderMutationBody =
  BodyType<DashboardReorderLeagueRegion>;
export type DashboardLeagueRegionsControllerReorderMutationError = ErrorType<
  | DashboardLeagueRegionsControllerReorder400
  | DashboardLeagueRegionsControllerReorder401
  | DashboardLeagueRegionsControllerReorder429
>;

/**
 * @summary Reorder league regions (dashboard)
 */
export const useDashboardLeagueRegionsControllerReorder = <
  TError = ErrorType<
    | DashboardLeagueRegionsControllerReorder400
    | DashboardLeagueRegionsControllerReorder401
    | DashboardLeagueRegionsControllerReorder429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeagueRegionsControllerReorder>>,
    TError,
    { data: BodyType<DashboardReorderLeagueRegion> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardLeagueRegionsControllerReorder>>,
  TError,
  { data: BodyType<DashboardReorderLeagueRegion> },
  TContext
> => {
  const mutationOptions = getDashboardLeagueRegionsControllerReorderMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Partial update. `leagueId` (`lge_…`) scopes + authorizes the request; the `:id` (`reg_…`) must belong to that league (404 otherwise). `seasonIds` present (even empty) REPLACES the season set (each must be same-league); absent leaves associations unchanged.
 * @summary Update a league region (dashboard)
 */
export const dashboardLeagueRegionsControllerUpdate = (
  id: string,
  dashboardUpdateLeagueRegion: BodyType<DashboardUpdateLeagueRegion>,
  params: DashboardLeagueRegionsControllerUpdateParams,
  options?: SecondParameter<typeof restClient>
) => {
  return restClient<LeagueRegion>(
    {
      url: `/api/dashboard/v1/league-regions/${id}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: dashboardUpdateLeagueRegion,
      params,
    },
    options
  );
};

export const getDashboardLeagueRegionsControllerUpdateMutationOptions = <
  TError = ErrorType<
    | DashboardLeagueRegionsControllerUpdate400
    | DashboardLeagueRegionsControllerUpdate401
    | DashboardLeagueRegionsControllerUpdate404
    | DashboardLeagueRegionsControllerUpdate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeagueRegionsControllerUpdate>>,
    TError,
    {
      id: string;
      data: BodyType<DashboardUpdateLeagueRegion>;
      params: DashboardLeagueRegionsControllerUpdateParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardLeagueRegionsControllerUpdate>>,
  TError,
  {
    id: string;
    data: BodyType<DashboardUpdateLeagueRegion>;
    params: DashboardLeagueRegionsControllerUpdateParams;
  },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardLeagueRegionsControllerUpdate>>,
    {
      id: string;
      data: BodyType<DashboardUpdateLeagueRegion>;
      params: DashboardLeagueRegionsControllerUpdateParams;
    }
  > = (props) => {
    const { id, data, params } = props ?? {};

    return dashboardLeagueRegionsControllerUpdate(id, data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardLeagueRegionsControllerUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeagueRegionsControllerUpdate>>
>;
export type DashboardLeagueRegionsControllerUpdateMutationBody =
  BodyType<DashboardUpdateLeagueRegion>;
export type DashboardLeagueRegionsControllerUpdateMutationError = ErrorType<
  | DashboardLeagueRegionsControllerUpdate400
  | DashboardLeagueRegionsControllerUpdate401
  | DashboardLeagueRegionsControllerUpdate404
  | DashboardLeagueRegionsControllerUpdate429
>;

/**
 * @summary Update a league region (dashboard)
 */
export const useDashboardLeagueRegionsControllerUpdate = <
  TError = ErrorType<
    | DashboardLeagueRegionsControllerUpdate400
    | DashboardLeagueRegionsControllerUpdate401
    | DashboardLeagueRegionsControllerUpdate404
    | DashboardLeagueRegionsControllerUpdate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeagueRegionsControllerUpdate>>,
    TError,
    {
      id: string;
      data: BodyType<DashboardUpdateLeagueRegion>;
      params: DashboardLeagueRegionsControllerUpdateParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardLeagueRegionsControllerUpdate>>,
  TError,
  {
    id: string;
    data: BodyType<DashboardUpdateLeagueRegion>;
    params: DashboardLeagueRegionsControllerUpdateParams;
  },
  TContext
> => {
  const mutationOptions = getDashboardLeagueRegionsControllerUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Delete a region. `leagueId` (`lge_…`) scopes + authorizes the request; the `:id` (`reg_…`) must belong to that league (404 otherwise). Association links cascade away.
 * @summary Delete a league region (dashboard)
 */
export const dashboardLeagueRegionsControllerRemove = (
  id: string,
  params: DashboardLeagueRegionsControllerRemoveParams,
  options?: SecondParameter<typeof restClient>
) => {
  return restClient<void>(
    { url: `/api/dashboard/v1/league-regions/${id}`, method: "DELETE", params },
    options
  );
};

export const getDashboardLeagueRegionsControllerRemoveMutationOptions = <
  TError = ErrorType<
    | DashboardLeagueRegionsControllerRemove400
    | DashboardLeagueRegionsControllerRemove401
    | DashboardLeagueRegionsControllerRemove404
    | DashboardLeagueRegionsControllerRemove429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeagueRegionsControllerRemove>>,
    TError,
    { id: string; params: DashboardLeagueRegionsControllerRemoveParams },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardLeagueRegionsControllerRemove>>,
  TError,
  { id: string; params: DashboardLeagueRegionsControllerRemoveParams },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardLeagueRegionsControllerRemove>>,
    { id: string; params: DashboardLeagueRegionsControllerRemoveParams }
  > = (props) => {
    const { id, params } = props ?? {};

    return dashboardLeagueRegionsControllerRemove(id, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardLeagueRegionsControllerRemoveMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeagueRegionsControllerRemove>>
>;

export type DashboardLeagueRegionsControllerRemoveMutationError = ErrorType<
  | DashboardLeagueRegionsControllerRemove400
  | DashboardLeagueRegionsControllerRemove401
  | DashboardLeagueRegionsControllerRemove404
  | DashboardLeagueRegionsControllerRemove429
>;

/**
 * @summary Delete a league region (dashboard)
 */
export const useDashboardLeagueRegionsControllerRemove = <
  TError = ErrorType<
    | DashboardLeagueRegionsControllerRemove400
    | DashboardLeagueRegionsControllerRemove401
    | DashboardLeagueRegionsControllerRemove404
    | DashboardLeagueRegionsControllerRemove429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeagueRegionsControllerRemove>>,
    TError,
    { id: string; params: DashboardLeagueRegionsControllerRemoveParams },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardLeagueRegionsControllerRemove>>,
  TError,
  { id: string; params: DashboardLeagueRegionsControllerRemoveParams },
  TContext
> => {
  const mutationOptions = getDashboardLeagueRegionsControllerRemoveMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * A league's levels with their seasons + regions, ordered by sorting position (nulls last, then creation time). `leagueId` (`lge_…`) is required and access-checked; the league must be a `LEAGUE`. Optional `keyword` filters on the title; optional `seasonIds` (`sea_…`) / `regionIds` (`reg_…`) narrow to levels belonging to the given seasons / regions. Not paginated.
 * @summary List league levels (dashboard)
 */
export const dashboardLeagueLevelsControllerList = (
  params: DashboardLeagueLevelsControllerListParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<LeagueLevel[]>(
    { url: `/api/dashboard/v1/league-levels`, method: "GET", params, signal },
    options
  );
};

export const getDashboardLeagueLevelsControllerListQueryKey = (
  params: DashboardLeagueLevelsControllerListParams
) => {
  return [`/api/dashboard/v1/league-levels`, ...(params ? [params] : [])] as const;
};

export const getDashboardLeagueLevelsControllerListQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardLeagueLevelsControllerList>>,
  TError = ErrorType<
    | DashboardLeagueLevelsControllerList400
    | DashboardLeagueLevelsControllerList401
    | DashboardLeagueLevelsControllerList429
  >,
>(
  params: DashboardLeagueLevelsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueLevelsControllerList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardLeagueLevelsControllerListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardLeagueLevelsControllerList>>> = ({
    signal,
  }) => dashboardLeagueLevelsControllerList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardLeagueLevelsControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardLeagueLevelsControllerListQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeagueLevelsControllerList>>
>;
export type DashboardLeagueLevelsControllerListQueryError = ErrorType<
  | DashboardLeagueLevelsControllerList400
  | DashboardLeagueLevelsControllerList401
  | DashboardLeagueLevelsControllerList429
>;

export function useDashboardLeagueLevelsControllerList<
  TData = Awaited<ReturnType<typeof dashboardLeagueLevelsControllerList>>,
  TError = ErrorType<
    | DashboardLeagueLevelsControllerList400
    | DashboardLeagueLevelsControllerList401
    | DashboardLeagueLevelsControllerList429
  >,
>(
  params: DashboardLeagueLevelsControllerListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueLevelsControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeagueLevelsControllerList>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeagueLevelsControllerList<
  TData = Awaited<ReturnType<typeof dashboardLeagueLevelsControllerList>>,
  TError = ErrorType<
    | DashboardLeagueLevelsControllerList400
    | DashboardLeagueLevelsControllerList401
    | DashboardLeagueLevelsControllerList429
  >,
>(
  params: DashboardLeagueLevelsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueLevelsControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeagueLevelsControllerList>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeagueLevelsControllerList<
  TData = Awaited<ReturnType<typeof dashboardLeagueLevelsControllerList>>,
  TError = ErrorType<
    | DashboardLeagueLevelsControllerList400
    | DashboardLeagueLevelsControllerList401
    | DashboardLeagueLevelsControllerList429
  >,
>(
  params: DashboardLeagueLevelsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueLevelsControllerList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List league levels (dashboard)
 */

export function useDashboardLeagueLevelsControllerList<
  TData = Awaited<ReturnType<typeof dashboardLeagueLevelsControllerList>>,
  TError = ErrorType<
    | DashboardLeagueLevelsControllerList400
    | DashboardLeagueLevelsControllerList401
    | DashboardLeagueLevelsControllerList429
  >,
>(
  params: DashboardLeagueLevelsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueLevelsControllerList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardLeagueLevelsControllerListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a level under `leagueId` (`lge_…`), attaching the given seasons + regions (empty/omitted ⇒ all of that dimension). Every `sea_…` / `reg_…` id must belong to the same league (else 400). Appends last.
 * @summary Create a league level (dashboard)
 */
export const dashboardLeagueLevelsControllerCreate = (
  dashboardCreateLeagueLevel: BodyType<DashboardCreateLeagueLevel>,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<LeagueLevel>(
    {
      url: `/api/dashboard/v1/league-levels`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: dashboardCreateLeagueLevel,
      signal,
    },
    options
  );
};

export const getDashboardLeagueLevelsControllerCreateMutationOptions = <
  TError = ErrorType<
    | DashboardLeagueLevelsControllerCreate400
    | DashboardLeagueLevelsControllerCreate401
    | DashboardLeagueLevelsControllerCreate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeagueLevelsControllerCreate>>,
    TError,
    { data: BodyType<DashboardCreateLeagueLevel> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardLeagueLevelsControllerCreate>>,
  TError,
  { data: BodyType<DashboardCreateLeagueLevel> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardLeagueLevelsControllerCreate>>,
    { data: BodyType<DashboardCreateLeagueLevel> }
  > = (props) => {
    const { data } = props ?? {};

    return dashboardLeagueLevelsControllerCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardLeagueLevelsControllerCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeagueLevelsControllerCreate>>
>;
export type DashboardLeagueLevelsControllerCreateMutationBody =
  BodyType<DashboardCreateLeagueLevel>;
export type DashboardLeagueLevelsControllerCreateMutationError = ErrorType<
  | DashboardLeagueLevelsControllerCreate400
  | DashboardLeagueLevelsControllerCreate401
  | DashboardLeagueLevelsControllerCreate429
>;

/**
 * @summary Create a league level (dashboard)
 */
export const useDashboardLeagueLevelsControllerCreate = <
  TError = ErrorType<
    | DashboardLeagueLevelsControllerCreate400
    | DashboardLeagueLevelsControllerCreate401
    | DashboardLeagueLevelsControllerCreate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeagueLevelsControllerCreate>>,
    TError,
    { data: BodyType<DashboardCreateLeagueLevel> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardLeagueLevelsControllerCreate>>,
  TError,
  { data: BodyType<DashboardCreateLeagueLevel> },
  TContext
> => {
  const mutationOptions = getDashboardLeagueLevelsControllerCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Rewrite the sort order of a league's levels. `ids` must be the FULL set of the league's level public ids (`lvl_…`) in the desired order — partial/extra/foreign sets are a 400.
 * @summary Reorder league levels (dashboard)
 */
export const dashboardLeagueLevelsControllerReorder = (
  dashboardReorderLeagueLevel: BodyType<DashboardReorderLeagueLevel>,
  options?: SecondParameter<typeof restClient>
) => {
  return restClient<LeagueLevel[]>(
    {
      url: `/api/dashboard/v1/league-levels/reorder`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: dashboardReorderLeagueLevel,
    },
    options
  );
};

export const getDashboardLeagueLevelsControllerReorderMutationOptions = <
  TError = ErrorType<
    | DashboardLeagueLevelsControllerReorder400
    | DashboardLeagueLevelsControllerReorder401
    | DashboardLeagueLevelsControllerReorder429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeagueLevelsControllerReorder>>,
    TError,
    { data: BodyType<DashboardReorderLeagueLevel> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardLeagueLevelsControllerReorder>>,
  TError,
  { data: BodyType<DashboardReorderLeagueLevel> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardLeagueLevelsControllerReorder>>,
    { data: BodyType<DashboardReorderLeagueLevel> }
  > = (props) => {
    const { data } = props ?? {};

    return dashboardLeagueLevelsControllerReorder(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardLeagueLevelsControllerReorderMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeagueLevelsControllerReorder>>
>;
export type DashboardLeagueLevelsControllerReorderMutationBody =
  BodyType<DashboardReorderLeagueLevel>;
export type DashboardLeagueLevelsControllerReorderMutationError = ErrorType<
  | DashboardLeagueLevelsControllerReorder400
  | DashboardLeagueLevelsControllerReorder401
  | DashboardLeagueLevelsControllerReorder429
>;

/**
 * @summary Reorder league levels (dashboard)
 */
export const useDashboardLeagueLevelsControllerReorder = <
  TError = ErrorType<
    | DashboardLeagueLevelsControllerReorder400
    | DashboardLeagueLevelsControllerReorder401
    | DashboardLeagueLevelsControllerReorder429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeagueLevelsControllerReorder>>,
    TError,
    { data: BodyType<DashboardReorderLeagueLevel> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardLeagueLevelsControllerReorder>>,
  TError,
  { data: BodyType<DashboardReorderLeagueLevel> },
  TContext
> => {
  const mutationOptions = getDashboardLeagueLevelsControllerReorderMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Partial update. `leagueId` (`lge_…`) scopes + authorizes the request; the `:id` (`lvl_…`) must belong to that league (404 otherwise). `seasonIds` / `regionIds` present (even empty) REPLACES that set (each must be same-league); absent leaves that set unchanged.
 * @summary Update a league level (dashboard)
 */
export const dashboardLeagueLevelsControllerUpdate = (
  id: string,
  dashboardUpdateLeagueLevel: BodyType<DashboardUpdateLeagueLevel>,
  params: DashboardLeagueLevelsControllerUpdateParams,
  options?: SecondParameter<typeof restClient>
) => {
  return restClient<LeagueLevel>(
    {
      url: `/api/dashboard/v1/league-levels/${id}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: dashboardUpdateLeagueLevel,
      params,
    },
    options
  );
};

export const getDashboardLeagueLevelsControllerUpdateMutationOptions = <
  TError = ErrorType<
    | DashboardLeagueLevelsControllerUpdate400
    | DashboardLeagueLevelsControllerUpdate401
    | DashboardLeagueLevelsControllerUpdate404
    | DashboardLeagueLevelsControllerUpdate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeagueLevelsControllerUpdate>>,
    TError,
    {
      id: string;
      data: BodyType<DashboardUpdateLeagueLevel>;
      params: DashboardLeagueLevelsControllerUpdateParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardLeagueLevelsControllerUpdate>>,
  TError,
  {
    id: string;
    data: BodyType<DashboardUpdateLeagueLevel>;
    params: DashboardLeagueLevelsControllerUpdateParams;
  },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardLeagueLevelsControllerUpdate>>,
    {
      id: string;
      data: BodyType<DashboardUpdateLeagueLevel>;
      params: DashboardLeagueLevelsControllerUpdateParams;
    }
  > = (props) => {
    const { id, data, params } = props ?? {};

    return dashboardLeagueLevelsControllerUpdate(id, data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardLeagueLevelsControllerUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeagueLevelsControllerUpdate>>
>;
export type DashboardLeagueLevelsControllerUpdateMutationBody =
  BodyType<DashboardUpdateLeagueLevel>;
export type DashboardLeagueLevelsControllerUpdateMutationError = ErrorType<
  | DashboardLeagueLevelsControllerUpdate400
  | DashboardLeagueLevelsControllerUpdate401
  | DashboardLeagueLevelsControllerUpdate404
  | DashboardLeagueLevelsControllerUpdate429
>;

/**
 * @summary Update a league level (dashboard)
 */
export const useDashboardLeagueLevelsControllerUpdate = <
  TError = ErrorType<
    | DashboardLeagueLevelsControllerUpdate400
    | DashboardLeagueLevelsControllerUpdate401
    | DashboardLeagueLevelsControllerUpdate404
    | DashboardLeagueLevelsControllerUpdate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeagueLevelsControllerUpdate>>,
    TError,
    {
      id: string;
      data: BodyType<DashboardUpdateLeagueLevel>;
      params: DashboardLeagueLevelsControllerUpdateParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardLeagueLevelsControllerUpdate>>,
  TError,
  {
    id: string;
    data: BodyType<DashboardUpdateLeagueLevel>;
    params: DashboardLeagueLevelsControllerUpdateParams;
  },
  TContext
> => {
  const mutationOptions = getDashboardLeagueLevelsControllerUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Delete a level. `leagueId` (`lge_…`) scopes + authorizes the request; the `:id` (`lvl_…`) must belong to that league (404 otherwise). Association links cascade away.
 * @summary Delete a league level (dashboard)
 */
export const dashboardLeagueLevelsControllerRemove = (
  id: string,
  params: DashboardLeagueLevelsControllerRemoveParams,
  options?: SecondParameter<typeof restClient>
) => {
  return restClient<void>(
    { url: `/api/dashboard/v1/league-levels/${id}`, method: "DELETE", params },
    options
  );
};

export const getDashboardLeagueLevelsControllerRemoveMutationOptions = <
  TError = ErrorType<
    | DashboardLeagueLevelsControllerRemove400
    | DashboardLeagueLevelsControllerRemove401
    | DashboardLeagueLevelsControllerRemove404
    | DashboardLeagueLevelsControllerRemove429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeagueLevelsControllerRemove>>,
    TError,
    { id: string; params: DashboardLeagueLevelsControllerRemoveParams },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardLeagueLevelsControllerRemove>>,
  TError,
  { id: string; params: DashboardLeagueLevelsControllerRemoveParams },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardLeagueLevelsControllerRemove>>,
    { id: string; params: DashboardLeagueLevelsControllerRemoveParams }
  > = (props) => {
    const { id, params } = props ?? {};

    return dashboardLeagueLevelsControllerRemove(id, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardLeagueLevelsControllerRemoveMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeagueLevelsControllerRemove>>
>;

export type DashboardLeagueLevelsControllerRemoveMutationError = ErrorType<
  | DashboardLeagueLevelsControllerRemove400
  | DashboardLeagueLevelsControllerRemove401
  | DashboardLeagueLevelsControllerRemove404
  | DashboardLeagueLevelsControllerRemove429
>;

/**
 * @summary Delete a league level (dashboard)
 */
export const useDashboardLeagueLevelsControllerRemove = <
  TError = ErrorType<
    | DashboardLeagueLevelsControllerRemove400
    | DashboardLeagueLevelsControllerRemove401
    | DashboardLeagueLevelsControllerRemove404
    | DashboardLeagueLevelsControllerRemove429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeagueLevelsControllerRemove>>,
    TError,
    { id: string; params: DashboardLeagueLevelsControllerRemoveParams },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardLeagueLevelsControllerRemove>>,
  TError,
  { id: string; params: DashboardLeagueLevelsControllerRemoveParams },
  TContext
> => {
  const mutationOptions = getDashboardLeagueLevelsControllerRemoveMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * A league's custom tags with their seasons + regions + levels, ordered by sorting position (nulls last, then creation time). `leagueId` (`lge_…`) is required and access-checked; the league must be a `LEAGUE`. Optional `keyword` filters on the title; optional `seasonIds` (`sea_…`) / `regionIds` (`reg_…`) / `levelIds` (`lvl_…`) narrow to tags belonging to the given seasons / regions / levels. Not paginated.
 * @summary List league custom tags (dashboard)
 */
export const dashboardLeagueCustomTagsControllerList = (
  params: DashboardLeagueCustomTagsControllerListParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<LeagueCustomTag[]>(
    { url: `/api/dashboard/v1/league-custom-tags`, method: "GET", params, signal },
    options
  );
};

export const getDashboardLeagueCustomTagsControllerListQueryKey = (
  params: DashboardLeagueCustomTagsControllerListParams
) => {
  return [`/api/dashboard/v1/league-custom-tags`, ...(params ? [params] : [])] as const;
};

export const getDashboardLeagueCustomTagsControllerListQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardLeagueCustomTagsControllerList>>,
  TError = ErrorType<
    | DashboardLeagueCustomTagsControllerList400
    | DashboardLeagueCustomTagsControllerList401
    | DashboardLeagueCustomTagsControllerList429
  >,
>(
  params: DashboardLeagueCustomTagsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueCustomTagsControllerList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardLeagueCustomTagsControllerListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardLeagueCustomTagsControllerList>>
  > = ({ signal }) => dashboardLeagueCustomTagsControllerList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardLeagueCustomTagsControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardLeagueCustomTagsControllerListQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeagueCustomTagsControllerList>>
>;
export type DashboardLeagueCustomTagsControllerListQueryError = ErrorType<
  | DashboardLeagueCustomTagsControllerList400
  | DashboardLeagueCustomTagsControllerList401
  | DashboardLeagueCustomTagsControllerList429
>;

export function useDashboardLeagueCustomTagsControllerList<
  TData = Awaited<ReturnType<typeof dashboardLeagueCustomTagsControllerList>>,
  TError = ErrorType<
    | DashboardLeagueCustomTagsControllerList400
    | DashboardLeagueCustomTagsControllerList401
    | DashboardLeagueCustomTagsControllerList429
  >,
>(
  params: DashboardLeagueCustomTagsControllerListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueCustomTagsControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeagueCustomTagsControllerList>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeagueCustomTagsControllerList<
  TData = Awaited<ReturnType<typeof dashboardLeagueCustomTagsControllerList>>,
  TError = ErrorType<
    | DashboardLeagueCustomTagsControllerList400
    | DashboardLeagueCustomTagsControllerList401
    | DashboardLeagueCustomTagsControllerList429
  >,
>(
  params: DashboardLeagueCustomTagsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueCustomTagsControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeagueCustomTagsControllerList>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeagueCustomTagsControllerList<
  TData = Awaited<ReturnType<typeof dashboardLeagueCustomTagsControllerList>>,
  TError = ErrorType<
    | DashboardLeagueCustomTagsControllerList400
    | DashboardLeagueCustomTagsControllerList401
    | DashboardLeagueCustomTagsControllerList429
  >,
>(
  params: DashboardLeagueCustomTagsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueCustomTagsControllerList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List league custom tags (dashboard)
 */

export function useDashboardLeagueCustomTagsControllerList<
  TData = Awaited<ReturnType<typeof dashboardLeagueCustomTagsControllerList>>,
  TError = ErrorType<
    | DashboardLeagueCustomTagsControllerList400
    | DashboardLeagueCustomTagsControllerList401
    | DashboardLeagueCustomTagsControllerList429
  >,
>(
  params: DashboardLeagueCustomTagsControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeagueCustomTagsControllerList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardLeagueCustomTagsControllerListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a custom tag under `leagueId` (`lge_…`), attaching the given seasons + regions + levels (empty/omitted ⇒ all of that dimension). Every `sea_…` / `reg_…` / `lvl_…` id must belong to the same league (else 400). Appends last.
 * @summary Create a league custom tag (dashboard)
 */
export const dashboardLeagueCustomTagsControllerCreate = (
  dashboardCreateLeagueCustomTag: BodyType<DashboardCreateLeagueCustomTag>,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<LeagueCustomTag>(
    {
      url: `/api/dashboard/v1/league-custom-tags`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: dashboardCreateLeagueCustomTag,
      signal,
    },
    options
  );
};

export const getDashboardLeagueCustomTagsControllerCreateMutationOptions = <
  TError = ErrorType<
    | DashboardLeagueCustomTagsControllerCreate400
    | DashboardLeagueCustomTagsControllerCreate401
    | DashboardLeagueCustomTagsControllerCreate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeagueCustomTagsControllerCreate>>,
    TError,
    { data: BodyType<DashboardCreateLeagueCustomTag> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardLeagueCustomTagsControllerCreate>>,
  TError,
  { data: BodyType<DashboardCreateLeagueCustomTag> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardLeagueCustomTagsControllerCreate>>,
    { data: BodyType<DashboardCreateLeagueCustomTag> }
  > = (props) => {
    const { data } = props ?? {};

    return dashboardLeagueCustomTagsControllerCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardLeagueCustomTagsControllerCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeagueCustomTagsControllerCreate>>
>;
export type DashboardLeagueCustomTagsControllerCreateMutationBody =
  BodyType<DashboardCreateLeagueCustomTag>;
export type DashboardLeagueCustomTagsControllerCreateMutationError = ErrorType<
  | DashboardLeagueCustomTagsControllerCreate400
  | DashboardLeagueCustomTagsControllerCreate401
  | DashboardLeagueCustomTagsControllerCreate429
>;

/**
 * @summary Create a league custom tag (dashboard)
 */
export const useDashboardLeagueCustomTagsControllerCreate = <
  TError = ErrorType<
    | DashboardLeagueCustomTagsControllerCreate400
    | DashboardLeagueCustomTagsControllerCreate401
    | DashboardLeagueCustomTagsControllerCreate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeagueCustomTagsControllerCreate>>,
    TError,
    { data: BodyType<DashboardCreateLeagueCustomTag> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardLeagueCustomTagsControllerCreate>>,
  TError,
  { data: BodyType<DashboardCreateLeagueCustomTag> },
  TContext
> => {
  const mutationOptions = getDashboardLeagueCustomTagsControllerCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Rewrite the sort order of a league's custom tags. `ids` must be the FULL set of the league's custom tag public ids (`tag_…`) in the desired order — partial/extra/foreign sets are a 400.
 * @summary Reorder league custom tags (dashboard)
 */
export const dashboardLeagueCustomTagsControllerReorder = (
  dashboardReorderLeagueCustomTag: BodyType<DashboardReorderLeagueCustomTag>,
  options?: SecondParameter<typeof restClient>
) => {
  return restClient<LeagueCustomTag[]>(
    {
      url: `/api/dashboard/v1/league-custom-tags/reorder`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: dashboardReorderLeagueCustomTag,
    },
    options
  );
};

export const getDashboardLeagueCustomTagsControllerReorderMutationOptions = <
  TError = ErrorType<
    | DashboardLeagueCustomTagsControllerReorder400
    | DashboardLeagueCustomTagsControllerReorder401
    | DashboardLeagueCustomTagsControllerReorder429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeagueCustomTagsControllerReorder>>,
    TError,
    { data: BodyType<DashboardReorderLeagueCustomTag> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardLeagueCustomTagsControllerReorder>>,
  TError,
  { data: BodyType<DashboardReorderLeagueCustomTag> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardLeagueCustomTagsControllerReorder>>,
    { data: BodyType<DashboardReorderLeagueCustomTag> }
  > = (props) => {
    const { data } = props ?? {};

    return dashboardLeagueCustomTagsControllerReorder(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardLeagueCustomTagsControllerReorderMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeagueCustomTagsControllerReorder>>
>;
export type DashboardLeagueCustomTagsControllerReorderMutationBody =
  BodyType<DashboardReorderLeagueCustomTag>;
export type DashboardLeagueCustomTagsControllerReorderMutationError = ErrorType<
  | DashboardLeagueCustomTagsControllerReorder400
  | DashboardLeagueCustomTagsControllerReorder401
  | DashboardLeagueCustomTagsControllerReorder429
>;

/**
 * @summary Reorder league custom tags (dashboard)
 */
export const useDashboardLeagueCustomTagsControllerReorder = <
  TError = ErrorType<
    | DashboardLeagueCustomTagsControllerReorder400
    | DashboardLeagueCustomTagsControllerReorder401
    | DashboardLeagueCustomTagsControllerReorder429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeagueCustomTagsControllerReorder>>,
    TError,
    { data: BodyType<DashboardReorderLeagueCustomTag> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardLeagueCustomTagsControllerReorder>>,
  TError,
  { data: BodyType<DashboardReorderLeagueCustomTag> },
  TContext
> => {
  const mutationOptions = getDashboardLeagueCustomTagsControllerReorderMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Partial update. `leagueId` (`lge_…`) scopes + authorizes the request; the `:id` (`tag_…`) must belong to that league (404 otherwise). `seasonIds` / `regionIds` / `levelIds` present (even empty) REPLACES that set (each must be same-league); absent leaves that set unchanged.
 * @summary Update a league custom tag (dashboard)
 */
export const dashboardLeagueCustomTagsControllerUpdate = (
  id: string,
  dashboardUpdateLeagueCustomTag: BodyType<DashboardUpdateLeagueCustomTag>,
  params: DashboardLeagueCustomTagsControllerUpdateParams,
  options?: SecondParameter<typeof restClient>
) => {
  return restClient<LeagueCustomTag>(
    {
      url: `/api/dashboard/v1/league-custom-tags/${id}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: dashboardUpdateLeagueCustomTag,
      params,
    },
    options
  );
};

export const getDashboardLeagueCustomTagsControllerUpdateMutationOptions = <
  TError = ErrorType<
    | DashboardLeagueCustomTagsControllerUpdate400
    | DashboardLeagueCustomTagsControllerUpdate401
    | DashboardLeagueCustomTagsControllerUpdate404
    | DashboardLeagueCustomTagsControllerUpdate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeagueCustomTagsControllerUpdate>>,
    TError,
    {
      id: string;
      data: BodyType<DashboardUpdateLeagueCustomTag>;
      params: DashboardLeagueCustomTagsControllerUpdateParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardLeagueCustomTagsControllerUpdate>>,
  TError,
  {
    id: string;
    data: BodyType<DashboardUpdateLeagueCustomTag>;
    params: DashboardLeagueCustomTagsControllerUpdateParams;
  },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardLeagueCustomTagsControllerUpdate>>,
    {
      id: string;
      data: BodyType<DashboardUpdateLeagueCustomTag>;
      params: DashboardLeagueCustomTagsControllerUpdateParams;
    }
  > = (props) => {
    const { id, data, params } = props ?? {};

    return dashboardLeagueCustomTagsControllerUpdate(id, data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardLeagueCustomTagsControllerUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeagueCustomTagsControllerUpdate>>
>;
export type DashboardLeagueCustomTagsControllerUpdateMutationBody =
  BodyType<DashboardUpdateLeagueCustomTag>;
export type DashboardLeagueCustomTagsControllerUpdateMutationError = ErrorType<
  | DashboardLeagueCustomTagsControllerUpdate400
  | DashboardLeagueCustomTagsControllerUpdate401
  | DashboardLeagueCustomTagsControllerUpdate404
  | DashboardLeagueCustomTagsControllerUpdate429
>;

/**
 * @summary Update a league custom tag (dashboard)
 */
export const useDashboardLeagueCustomTagsControllerUpdate = <
  TError = ErrorType<
    | DashboardLeagueCustomTagsControllerUpdate400
    | DashboardLeagueCustomTagsControllerUpdate401
    | DashboardLeagueCustomTagsControllerUpdate404
    | DashboardLeagueCustomTagsControllerUpdate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeagueCustomTagsControllerUpdate>>,
    TError,
    {
      id: string;
      data: BodyType<DashboardUpdateLeagueCustomTag>;
      params: DashboardLeagueCustomTagsControllerUpdateParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardLeagueCustomTagsControllerUpdate>>,
  TError,
  {
    id: string;
    data: BodyType<DashboardUpdateLeagueCustomTag>;
    params: DashboardLeagueCustomTagsControllerUpdateParams;
  },
  TContext
> => {
  const mutationOptions = getDashboardLeagueCustomTagsControllerUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Delete a custom tag. `leagueId` (`lge_…`) scopes + authorizes the request; the `:id` (`tag_…`) must belong to that league (404 otherwise). Association links cascade away.
 * @summary Delete a league custom tag (dashboard)
 */
export const dashboardLeagueCustomTagsControllerRemove = (
  id: string,
  params: DashboardLeagueCustomTagsControllerRemoveParams,
  options?: SecondParameter<typeof restClient>
) => {
  return restClient<void>(
    { url: `/api/dashboard/v1/league-custom-tags/${id}`, method: "DELETE", params },
    options
  );
};

export const getDashboardLeagueCustomTagsControllerRemoveMutationOptions = <
  TError = ErrorType<
    | DashboardLeagueCustomTagsControllerRemove400
    | DashboardLeagueCustomTagsControllerRemove401
    | DashboardLeagueCustomTagsControllerRemove404
    | DashboardLeagueCustomTagsControllerRemove429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeagueCustomTagsControllerRemove>>,
    TError,
    { id: string; params: DashboardLeagueCustomTagsControllerRemoveParams },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardLeagueCustomTagsControllerRemove>>,
  TError,
  { id: string; params: DashboardLeagueCustomTagsControllerRemoveParams },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardLeagueCustomTagsControllerRemove>>,
    { id: string; params: DashboardLeagueCustomTagsControllerRemoveParams }
  > = (props) => {
    const { id, params } = props ?? {};

    return dashboardLeagueCustomTagsControllerRemove(id, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardLeagueCustomTagsControllerRemoveMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeagueCustomTagsControllerRemove>>
>;

export type DashboardLeagueCustomTagsControllerRemoveMutationError = ErrorType<
  | DashboardLeagueCustomTagsControllerRemove400
  | DashboardLeagueCustomTagsControllerRemove401
  | DashboardLeagueCustomTagsControllerRemove404
  | DashboardLeagueCustomTagsControllerRemove429
>;

/**
 * @summary Delete a league custom tag (dashboard)
 */
export const useDashboardLeagueCustomTagsControllerRemove = <
  TError = ErrorType<
    | DashboardLeagueCustomTagsControllerRemove400
    | DashboardLeagueCustomTagsControllerRemove401
    | DashboardLeagueCustomTagsControllerRemove404
    | DashboardLeagueCustomTagsControllerRemove429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeagueCustomTagsControllerRemove>>,
    TError,
    { id: string; params: DashboardLeagueCustomTagsControllerRemoveParams },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardLeagueCustomTagsControllerRemove>>,
  TError,
  { id: string; params: DashboardLeagueCustomTagsControllerRemoveParams },
  TContext
> => {
  const mutationOptions = getDashboardLeagueCustomTagsControllerRemoveMutationOptions(options);

  return useMutation(mutationOptions);
};
